import type { RadioChangeEvent } from "antd";
import { Radio, Typography } from "antd";
import type { CheckboxOptionType } from "antd/es/checkbox/Group";
import type { RadioGroupProps } from "antd/es/radio";
import React, { useCallback } from "react";
import styles from "./AppSegmented.module.scss";

export type AppSegmentedOption = CheckboxOptionType;
export type AppSegmentedValue = CheckboxOptionType["value"];

export type AppSegmentedProps = Omit<RadioGroupProps, "children" | "onChange"> & {
  label?: React.ReactNode;
  options: AppSegmentedOption[];
  onChange?: (value: AppSegmentedValue) => void;
};

const { Text } = Typography;

const cx = (...classNames: Array<string | undefined | false>) => classNames.filter(Boolean).join(" ");

export function AppSegmented(props: AppSegmentedProps) {
  const {
    label,
    className,
    style,
    size = "middle",
    optionType = "button",
    buttonStyle = "solid",
    options = [],
    value,
    defaultValue,
    onChange,
    disabled,
    name,
  } = props;

  const handleChange = useCallback(
    (event: RadioChangeEvent) => {
      onChange?.(event.target.value);
    },
    [onChange],
  );

  return (
    <div className={cx(styles.root, size === "small" && styles.small, className)} style={style}>
      {label != null && <Text className={styles.label}>{label}</Text>}
      <Radio.Group
        className={styles.control}
        optionType={optionType}
        buttonStyle={buttonStyle}
        size={size}
        options={options}
        value={value}
        defaultValue={defaultValue}
        onChange={handleChange}
        disabled={disabled}
        name={name}
      />
    </div>
  );
}
